import { useSearchParams } from 'react-router-dom';
import { REGISTER_ID_SEARCH_PARAM_KEY } from '@/modules/common/constants/search-params.ts';
import { DropdownMenuItem } from 'ui';
import { GetEntityShareholdersResponse } from 'api';

export const useSidebarHeaderMenuOptions = (
  shareholders?: GetEntityShareholdersResponse,
): DropdownMenuItem[] => {
  const [params, setParams] = useSearchParams();

  const defaultOption: DropdownMenuItem = {
    label: 'All registers',
    onClick: () => {
      params.set(REGISTER_ID_SEARCH_PARAM_KEY, 'all');
      setParams(params, { replace: false });
    },
    value: 'all',
  };

  const options: DropdownMenuItem[] = shareholders
    ? shareholders.shareholders.map(({ register_obj, register_id }) => ({
        label: (
          <div className="flex gap-3 items-center">
            {register_obj?.icon_url && (
              <span className="bg-white border-white border">
                <img src={register_obj?.icon_url} alt="icon" className="w-6 h-6 max-w-6 max-h-6" />
              </span>
            )}
            <span>{register_obj?.name || ''}</span>
          </div>
        ),
        onClick: () => {
          params.set(REGISTER_ID_SEARCH_PARAM_KEY, String(register_id));
          setParams(params, { replace: false });
        },
        value: String(register_id),
      }))
    : [];

  if (!options.length) {
    return [{ value: '-', label: '----------------', onClick: () => 0 }];
  }

  return options.length > 1 ? [defaultOption, ...options] : options;
};
